export default function staticSignup() {
  const useTitle = true;
  const useDescription = true;
  const signupTitle = 'Wild West Updates ';
  const signupTdescription =
    'Don’t be left behind! Sign up today for the latest entertainment and live music updates and get them delivered to your inbox!';
  const inputPlaceholder = 'Email Address';
  const buttonLabel = 'Subscribe';

  const $signupElement = $('.seo-signup-container .emailSignup');
  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
      <div class="signup-text">
        ${useTitle ? `<h2 class="signup-title" aria-label="${signupTitle}">${signupTitle}</h2>` : ''}
        ${useDescription ? `<p class="signup-description">${signupTdescription}</p>` : ''}
      </div>
    `);

  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel);
}
